// config/navigationConfig.js
import {
    TbLayoutDashboard,
    AiOutlineSetting,
    FiUsers,
    FiUser,
    FaLaptopHouse,
    FaUmbrellaBeach,
    AiTwotoneCalendar,
    RiTaskLine,
    BsCash,
    MdFlightTakeoff,
    BsFillCalendarCheckFill,
    BsFillCalendarDayFill,
    BsListTask,
    BsFillCreditCard2BackFill,
} from "../utils/iconImports";

export const navigationConfig = {
    Admin: [
        {
            key: "dashboard",
            label: "Dashboard",
            icon: TbLayoutDashboard,
            menu: "Dashboard",
            route: "/backend/admin/dashboard",
        },
        {
            key: "employees",
            label: "Employees",
            icon: FiUsers,
            menu: "Employees",
            route: "/backend/admin/employees",
        },
        {
            key: "attendance",
            label: "Attendance",
            icon: BsFillCalendarDayFill,
            menu: "Attendance",
            route: "/backend/admin/attendance",
        },
        {
            key: "daily-task",
            label: "Daily Task",
            icon: RiTaskLine,
            menu: "Daily Task",
            route: "/backend/admin/daily-task",
        },
        {
            key: "task",
            label: "Task",
            icon: BsListTask,
            menu: "Task",
            route: "/backend/admin/task",
        },
        {
            key: "loan",
            label: "Loans",
            icon: BsCash,
            menu: "Loan",
            route: "/backend/admin/loans",
        },
        {
            key: "travel-expenses",
            label: "Travel Expenses",
            icon: MdFlightTakeoff,
            menu: "Travel Expenses",
            route: "/backend/admin/travel-expenses",
        },
        {
            key: "payslip",
            label: "Payslip",
            icon: BsFillCreditCard2BackFill,
            menu: "Payslip",
            route: "/backend/admin/payslip",
        },
        {
            key: "leaves",
            label: "Leaves",
            icon: FaUmbrellaBeach,
            menu: "Leaves",
            route: "/backend/admin/leaves",
        },
        {
            key: "manage-leave",
            label: "Manage Leave",
            icon: AiTwotoneCalendar,
            menu: "Manage Leave",
            route: "/backend/admin/manage-leave",
        },
        {
            key: "asset-allocation",
            label: "Asset Allocation",
            icon: FaLaptopHouse,
            menu: "Asset Allocation",
            route: "/backend/admin/asset-allocation",
        },
        {
            key: "superadmin",
            label: "Superadmin",
            icon: AiOutlineSetting,
            route: "/superadmin",
        },
    ],

    Manager: [
        {
            key: "my-details",
            label: "My Details",
            icon: FiUser,
            menu: "My Details",
            route: "/backend/manager/my-details",
        },
        {
            key: "my-attendance",
            label: "My Attendance",
            icon: BsFillCalendarCheckFill,
            menu: "My Attendance",
            route: "/backend/manager/my-attendance",
        },
        {
            key: "manager-attendance",
            label: "Attendance",
            icon: BsFillCalendarDayFill,
            menu: "Manager Attendance",
            route: "/backend/manager/attendance",
        },
        {
            key: "manager-daily-task",
            label: "Daily Task",
            icon: RiTaskLine,
            menu: "Manager Daily Task",
            route: "/backend/manager/daily-task",
        },
        {
            key: "manager-task",
            label: "Task",
            icon: BsListTask,
            menu: "Manager Task",
            route: "/backend/manager/task",
        },
        {
            key: "manager-asset-allocation",
            label: "Asset Allocation",
            icon: FaLaptopHouse,
            menu: "Manager Asset Allocation",
            route: "/backend/manager/asset-allocation",
        },
        {
            key: "manager-travel-expenses",
            label: "Travel Expenses",
            icon: MdFlightTakeoff,
            menu: "Manager Travel Expenses",
            route: "/backend/manager/travel-expenses",
        },
        {
            key: "leaves",
            label: "Leaves",
            icon: FaUmbrellaBeach,
            menu: "Leaves",
            route: "/backend/manager/leaves",
        },
    ],

    Employee: [
        {
            key: "my-details",
            label: "My Details",
            icon: FiUser,
            menu: "My Details",
            route: "/backend/employee/my-details",
        },
        {
            key: "my-attendance",
            label: "My Attendance",
            icon: BsFillCalendarCheckFill,
            menu: "My Attendance",
            route: "/backend/employee/my-attendance",
        },
        {
            key: "my-daily-task",
            label: "Daily Task",
            icon: RiTaskLine,
            menu: "My Daily Task",
            route: "/backend/employee/daily-task",
        },
        {
            key: "my-task",
            label: "My Task",
            icon: BsListTask,
            menu: "My Task",
            route: "/backend/employee/my-task",
        },
        {
            key: "my-leaves",
            label: "My Leaves",
            icon: FaUmbrellaBeach,
            menu: "My Leaves",
            route: "/backend/employee/my-leaves",
        },
        {
            key: "my-payslip",
            label: "My Payslip",
            icon: BsFillCreditCard2BackFill,
            menu: "My Payslip",
            route: "/backend/employee/my-payslip",
        },
        {
            key: "my-assets",
            label: "My Assets",
            icon: FaLaptopHouse,
            menu: "My Assets",
            route: "/backend/employee/my-assets",
        },
        {
            key: "my-travel-expenses",
            label: "My Travel Expenses",
            icon: MdFlightTakeoff,
            menu: "My Travel Expenses",
            route: "/backend/employee/my-travel-expenses",
        },
    ],

    "Asset Admin": [
        {
            key: "my-attendance",
            label: "My Attendance",
            icon: BsFillCalendarCheckFill,
            menu: "My Attendance",
            route: "/backend/asset-admin/my-attendance",
        },
        {
            key: "my-daily-task",
            label: "Daily Task",
            icon: RiTaskLine,
            menu: "My Daily Task",
            route: "/backend/asset-admin/daily-task",
        },
        {
            key: "my-task",
            label: "My Task",
            icon: BsListTask,
            menu: "My Task",
            route: "/backend/asset-admin/my-task",
        },
        {
            key: "my-leaves",
            label: "My Leaves",
            icon: FaUmbrellaBeach,
            menu: "My Leaves",
            route: "/backend/asset-admin/my-leaves",
        },
        {
            key: "my-assets",
            label: "My Assets",
            icon: FaLaptopHouse,
            menu: "My Assets",
            route: "/backend/asset-admin/my-assets",
        },
        {
            key: "asset-allocation",
            label: "Asset Allocation",
            icon: FaLaptopHouse,
            menu: "Asset Allocation",
            route: "/backend/asset-admin/asset-allocation",
        },
        {
            key: "divider-1",
            divider: true,
        },
        {
            key: "superadmin",
            label: "Superadmin",
            icon: AiOutlineSetting,
            route: "/superadmin",
        },
    ],
};